import * as React from "react";
import { UseFormReturn } from "react-hook-form";

const useUpdateFormErrors = (
  errors: null | undefined | Array<{ title: string; detail: string }>,
  setError: UseFormReturn["setError"] | any
) => {
  React.useEffect(() => {
    if (!Array.isArray(errors)) {
      return;
    }

    for (const error of errors) {
      setError(error.title as any, { message: error.detail });
    }
  }, [errors, setError]);
};

export default useUpdateFormErrors;
